import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

// Force scroll to top on every route change. Uses useLayoutEffect to run
// synchronously before paint, and also disables the browser's automatic
// scroll restoration so React doesn't restore previous scroll position.
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useLayoutEffect(() => {
    // Reset scroll for window AND main document element (covers all browsers)
    window.scrollTo(0, 0);
    if (document.documentElement) document.documentElement.scrollTop = 0;
    if (document.body) document.body.scrollTop = 0;
  }, [pathname]);

  // Belt + suspenders: also run after paint in case content shifts late
  useEffect(() => {
    const id = window.requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
    return () => window.cancelAnimationFrame(id);
  }, [pathname]);

  return null;
}
